import React, { useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { toast } from "react-toastify";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Table,
} from "reactstrap";
import { ArrowRight } from "react-bootstrap-icons";

import Header from "../../../components/Headers/Header";
import CustomTable from "../../../components/Tables/CustomTable";

import useTeacherId from "../../../Hooks/useTeacherId";
import useTeacherProfile from "../../../Hooks/useTeacherProfile";
import useTeacherMedium from "../../../Hooks/useTeacherMedium";
import { PATHS } from "../../../routes";
import { TypeTeacherSchool } from "../../../Reducers/types";
import {
  TypeAllAssessments,
  typeGradeSection,
  TypeSubject,
  TypeTopic,
} from "../../../types";
import {
  getAllAssessments,
  getTopics,
} from "../../../Services/Assessment/AssessmentService";
import LargeText from "../../../components/utils/LargeText";

export default function ShowAssessments() {
  const history = useHistory();
  const teacherProfile: TypeTeacherSchool = useTeacherProfile(); // stores teacher profile information
  const teacherMedium: number = useTeacherMedium(); // stores medium of logged in teacher

  // --- DROPDOWN ASSESSMENT TYPE ---
  const [typeDropdownOpen, setTypeDropdownOpen] = useState(false);
  const filterByCategoryToggle = () =>
    setTypeDropdownOpen((prevState) => !prevState);
  // --- DROPDOWN GRADE ---
  const [gradeDropdownOpen, setGradeDropdownOpen] = useState(false);
  const gradeDropdownToggle = () =>
    setGradeDropdownOpen((prevState) => !prevState);
  // --- DROPDOWN SUBJECT ---
  const [subjectDropdownOpen, setSubjectDropdownOpen] = useState(false);
  const subjectDropdownToggle = () =>
    setSubjectDropdownOpen((prevState) => !prevState);
  // --- DROPDOWN TOPICS ---
  const [topicDropdownOpen, setTopicDropdownOpen] = useState(false);
  const topicDropdownToggle = () =>
    setTopicDropdownOpen((prevState) => !prevState);

  // --- GRADE-SECTION-SUBJECT ---
  const [gradeSectionInfo, setGradeSectionInfo] = useState<typeGradeSection[]>(
    []
  ); // stores grade-section-subject information
  const [selectedGrade, setSelectedGrade] = useState<typeGradeSection>(); // stores selected grade
  // --- SUBJECTS ---
  const [subjects, setSubjects] = useState<TypeSubject[]>([]); // stores subject list
  const [selectedSubject, setSelectedSubject] = useState<TypeSubject>(); // stores id of selected subject
  // --- TOPICS ---
  const [topics, setTopics] = useState<TypeTopic[]>(); // stores topic list
  const [selectedTopics, setSelectedTopics] = useState<TypeTopic>(); // stores selected topic
  const addSelectedTopics = (topic) => {
    setSelectedTopics(topic);
  };

  const teacherId: number = useTeacherId(); // gets the logged in teacher's id
  const [filterByCategory, setFilterByCategory] =
    useState<string>("assessment"); // category for assessment/homework

  // const [allAssessments, setAllAssessments] = useState<TypeAllAssessments[]>([]); // stores all available assessments
  const [isLoading, setisLoading] = useState<boolean>(false); // if assessment is loading

  useEffect(() => {
    // fetchAssessments();
    filterGrades();
  }, []);
  useEffect(() => {
    filterSubjects();
    setSelectedSubject(null);
  }, [selectedGrade]);
  useEffect(() => {
    getTopicsList();
    setSelectedTopics(null);
  }, [selectedGrade, selectedSubject]);
  // useEffect(() => {}, [selectedGrade, selectedSubject])

  // useEffect(() => {
  //     fetchAssessments();
  // }, [filterByCategory]);

  // filters grades from teacher profile
  const filterGrades = () => {
    if (Number(teacherProfile?.gradelist.length) === 0) {
      toast.error("Can not get grades. Please log in again!");
    }
    // filters grade-section list based on current session
    setGradeSectionInfo(
      teacherProfile?.gradelist?.filter(({ grade_section_id, subject }) => {
        if (
          moment(new Date()).format("YYYY-MM-DD") >=
            moment(grade_section_id?.session?.session_start).format(
              "YYYY-MM-DD"
            ) &&
          moment(new Date()).format("YYYY-MM-DD") <=
            moment(grade_section_id?.session?.session_end).format("YYYY-MM-DD")
        ) {
          return { grade_section_id, subject };
        }
      })
    );
  };
  // filters subjects from teacher profile
  const filterSubjects = () => {
    let localSubjects: any = [];
    gradeSectionInfo?.forEach((each) => {
      if (
        each?.grade_section_id?.grade?.id ===
          selectedGrade?.grade_section_id?.grade?.id &&
        each?.grade_section_id?.section?.id ===
          selectedGrade?.grade_section_id?.section?.id
      ) {
        localSubjects.push(each?.subject);
      }
    });
    setSubjects(localSubjects.flat());
  };

  // fetch topics based on grade-section & subject selection
  const getTopicsList = () => {
    getTopics(
      selectedGrade?.grade_section_id?.grade?.id,
      selectedSubject?.subject_id?.id,
      teacherMedium
    )
      .then(
        (response) => {
          // console.log("Response For Topic List: ", response?.data?.data);
          setTopics(response?.data?.data);
        },
        (error) => {
          console.log("Error caught: ", error?.response);
        }
      )
      .catch((error) => console.log("Catched Error ---> ", error));
  };

  // fetches all available assessments based on category
  // const fetchAssessments = () => {
  //     setisLoading(true);
  //     getAllAssessments(teacherId, selectedGrade?.grade_section_id?.id, selectedSubject?.subject_id?.id, filterByCategory).then(
  //         (response) => {
  //             console.log("Response for all assessments: ", response?.data?.data);
  //             setAllAssessments(response?.data?.data);
  //             setisLoading(false);
  //         }, (error) => {
  //             console.log("Error caught: ", error?.response);
  //             toast.error("Can not show the assessments!");
  //             setisLoading(false);
  //         }
  //     ).catch(error => { console.log("Catched error ---> ", error); setisLoading(false) });
  // };

  return (
    <React.Fragment>
      <Header />

      <Container className="mt--7" fluid>
        <Card className="mb-4 mb-xl-0">
          <CardHeader className="border-0  ">
            <div className="d-flex justify-content-between">
              <h2 className="mb-0 text-muted">
                <i className="fas fa-file-invoice mr-1"></i>
                <span>
                  {filterByCategory === "homework" ? "Homework" : "Assessment"}
                </span>
              </h2>
              {/* filterByCategory === 'All' ? 'All' : filterByCategory === 'homework' ? 'Homework' : 'Assessment' */}
              <div className="d-flex">
                <Button
                  size="sm"
                  color="primary"
                  onClick={() => history.push(PATHS.createAssessment)}
                >
                  Create Task <ArrowRight />{" "}
                </Button>
              </div>
            </div>

            {/* FILTERS */}
            <div className=" p-2 mt-3 rounded filter-div-bg">
              {/* ASSESSMENT TYPE */}
              <Dropdown
                size="sm"
                isOpen={typeDropdownOpen}
                direction="down"
                toggle={filterByCategoryToggle}
              >
                <DropdownToggle caret>
                  {/* {filterByCategory ? <span>Assessment Type: <span className="text-primary text-capitalize">{filterByCategory}</span></span> : 'Select Assessment Type: '} */}
                  {
                    <span>
                      Task Type:{" "}
                      <span className="text-primary text-capitalize">
                        {filterByCategory}
                      </span>
                    </span>
                  }
                </DropdownToggle>
                <DropdownMenu style={{ maxHeight: 300, overflow: "auto" }}>
                  <DropdownItem
                    onClick={() => {
                      setFilterByCategory("assessment");
                    }}
                  >
                    <span className="d-flex justify-content-between align-items-center">
                      Assessment{" "}
                      {filterByCategory === "assessment" && (
                        <i className="fas fa-check-circle text-primary"></i>
                      )}
                    </span>
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => {
                      setFilterByCategory("homework");
                    }}
                  >
                    <span className="d-flex justify-content-between align-items-center">
                      Homework{" "}
                      {filterByCategory === "homework" && (
                        <i className="fas fa-check-circle text-primary"></i>
                      )}
                    </span>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
              {/* FOR GRADES */}
              <Dropdown
                size="sm"
                isOpen={gradeDropdownOpen}
                direction="down"
                toggle={gradeDropdownToggle}
              >
                <DropdownToggle caret>
                  {selectedGrade ? (
                    <span>
                      Selected Grade:{" "}
                      <span className="text-primary">
                        {selectedGrade?.grade_section_id?.grade?.name} -{" "}
                        {selectedGrade?.grade_section_id?.section?.type}
                      </span>
                    </span>
                  ) : (
                    "Select Grade"
                  )}
                </DropdownToggle>
                <DropdownMenu
                  modifiers={{
                    setMaxHeight: {
                      enabled: true,
                      order: 890,
                      fn: (data) => {
                        return {
                          ...data,
                          styles: {
                            ...data.styles,
                            overflow: "auto",
                            maxHeight: "200px",
                          },
                        };
                      },
                    },
                  }}
                >
                  {gradeSectionInfo?.length !== 0 ? (
                    gradeSectionInfo?.map((each, index) => (
                      <DropdownItem
                        key={index}
                        onClick={() => setSelectedGrade(each)}
                      >
                        <span className="d-flex justify-content-between align-items-center">
                          {each?.grade_section_id?.grade?.name} -{" "}
                          {each?.grade_section_id?.section?.type}
                          {selectedGrade?.grade_section_id?.grade?.id ===
                            each?.grade_section_id?.grade?.id && (
                            <i className="fas fa-check-circle text-primary"></i>
                          )}
                        </span>
                      </DropdownItem>
                    ))
                  ) : (
                    <span className="small text-muted text-center">
                      No Grades Available
                    </span>
                  )}
                </DropdownMenu>
              </Dropdown>
              {/* FOR SUBJECTS */}
              <Dropdown
                size="sm"
                isOpen={subjectDropdownOpen}
                direction="down"
                toggle={subjectDropdownToggle}
              >
                <DropdownToggle caret>
                  {selectedSubject ? (
                    <span>
                      Selected Subject:{" "}
                      <span className="text-primary">
                        {selectedSubject?.subject_id?.name}
                      </span>
                    </span>
                  ) : (
                    "Select Subject"
                  )}
                </DropdownToggle>
                <DropdownMenu
                  modifiers={{
                    setMaxHeight: {
                      enabled: true,
                      order: 890,
                      fn: (data) => {
                        return {
                          ...data,
                          styles: {
                            ...data.styles,
                            overflow: "auto",
                            maxHeight: "200px",
                          },
                        };
                      },
                    },
                  }}
                >
                  {subjects?.length !== 0 ? (
                    subjects?.map((each, index) => (
                      <DropdownItem
                        key={index}
                        onClick={() => setSelectedSubject(each)}
                      >
                        <span className="d-flex justify-content-between align-items-center">
                          {each?.subject_id?.name}{" "}
                          {selectedSubject?.subject_id?.id ===
                            each?.subject_id?.id && (
                            <i className="fas fa-check-circle text-primary"></i>
                          )}
                        </span>
                      </DropdownItem>
                    ))
                  ) : (
                    <span className="small text-muted text-center">
                      Please select a grade first
                    </span>
                  )}
                </DropdownMenu>
              </Dropdown>
              {/* FOR TOPICS */}
              {/* <Dropdown size="sm" isOpen={topicDropdownOpen} direction="left" toggle={topicDropdownToggle}>
                                <DropdownToggle caret>
                                    {selectedTopics ? <span>Selected Topic: <span className="text-primary">{selectedTopics?.name}</span></span> : 'Select Topic'}
                                </DropdownToggle>
                                <DropdownMenu
                                    modifiers={{
                                        setMaxHeight: {
                                            enabled: true,
                                            order: 890,
                                            fn: (data) => {
                                                return {
                                                    ...data,
                                                    styles: {
                                                        ...data.styles,
                                                        overflow: 'auto',
                                                        maxHeight: '200px',
                                                    },
                                                };
                                            },
                                        },
                                    }}>
                                    {
                                        topics?.length !== 0 ? topics?.map((each, index) => (
                                            <DropdownItem key={index} onClick={() => addSelectedTopics(each)}>
                                                <span className="d-flex justify-content-between align-items-center">
                                                    {each?.name} {selectedTopics?.id === each?.id && <i className="fas fa-check-circle text-primary"></i>}
                                                </span>
                                            </DropdownItem>
                                        )) : <span className="small text-muted text-center">Please select a grade and subject first</span>
                                    }
                                </DropdownMenu>
                            </Dropdown> */}
              <Button
                color="secondary"
                size="sm"
                disabled={!selectedGrade || !selectedSubject} //  || !selectedTopics
                onClick={() => {
                  setSelectedGrade(null);
                  setSelectedSubject(null);
                  setSelectedTopics(null);
                }}
              >
                Show All
              </Button>
            </div>
          </CardHeader>
          <CardBody
            className="overflow-auto pt-0"
            style={{ maxHeight: 600, minHeight: 300 }}
          >
            <CustomTable
              url={
                filterByCategory &&
                selectedGrade?.grade_section_id?.id &&
                selectedSubject?.subject_id?.id //  && selectedTopics?.id
                  ? `items/assessment?filter[assigned_by]=${teacherId}
                                  &filter[category]=${filterByCategory}&filter[grade]=${selectedGrade?.grade_section_id?.id}
                                  &filter[subject]=${selectedSubject?.subject_id?.id}
                                  &sort=-start_date&fields=id,title,subject.name,topics.topic_id.*,start_date,end_date,total_marks,total_time,category,no_of_questions,assigned_by,grade.grade.name,grade.section.type&sort=-created_on&limit=5&meta=filter_count&limit=5&meta=filter_count` // &filter[topic]=${selectedTopics?.id}
                  : `items/assessment?filter[assigned_by]=${teacherId}&filter[category]=${filterByCategory}&sort=-created_on&fields=id,title,subject.name,topics.topic_id.*,start_date,end_date,total_marks,total_time,category,no_of_questions,assigned_by,grade.grade.name,grade.section.type&sort=-created_on&limit=5&meta=filter_count&limit=5&meta=filter_count`
              }
              column={
                [
                  // { key: "id", label: "ID" },
                ]
              }
              tableTitle={""}
              searchBox={false}
              itemsLimit={5}
              customFunction={() => {}}
              customColumns={[
                {
                  heading: "#",
                  renderer: (item: any) => (
                    <span
                      className="font-weight-bold text-primary pointer"
                      onClick={() =>
                        history.push(PATHS.assessmentDetails + "/" + item?.id)
                      }
                    >
                      {item?.id}
                    </span>
                  ),
                },
                {
                  heading: "Grade",
                  renderer: (item: any) => (
                    <React.Fragment>
                      {item?.grade?.grade?.name} - {item?.grade?.section?.type}
                    </React.Fragment>
                  ),
                },
                {
                  heading: "Subject",
                  renderer: (item: any) => (
                    <React.Fragment>{item?.subject?.name}</React.Fragment>
                  ),
                },
                {
                  heading: "Topic",
                  renderer: (item: any) => (
                    <React.Fragment>
                      {/* {item?.topic?.name} */}
                      {item?.topics?.map((each, index) => (
                        <div key={index}>
                          <LargeText
                            data={each?.topic_id?.name}
                            lengthToBeShown={20}
                          />
                        </div>
                      ))}
                    </React.Fragment>
                  ),
                },
                {
                  heading: "Start Date",
                  renderer: (item: any) => (
                    <React.Fragment>
                      {moment(item?.start_date).format("MMM Do YYYY - hh:mm a")}
                    </React.Fragment>
                  ),
                },
                {
                  heading: "Due Date",
                  renderer: (item: any) => (
                    <React.Fragment>
                      {moment(item?.end_date).format("MMM Do YYYY - hh:mm a")}
                    </React.Fragment>
                  ),
                },
              ]}
            />
          </CardBody>
        </Card>
      </Container>
    </React.Fragment>
  );
}
